import { render, staticRenderFns } from "./setPayAccount.vue?vue&type=template&id=45565a88&"
import script from "./setPayAccount.vue?vue&type=script&lang=js&"
export * from "./setPayAccount.vue?vue&type=script&lang=js&"
import style0 from "./setPayAccount.vue?vue&type=style&index=0&id=45565a88&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports